/*
* ローカルストレージにセット
*/
export const setLocalStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  localStorage.setItem(name, content)
}

/**
 * ローカルストレージから取得
 */
export const getLocalStore = name => {
  if (!name) return
  return localStorage.getItem(name)
}

/**
 * ローカルストレージから削除
 */
export const removeLocalStore = name => {
  if (!name) return
  localStorage.removeItem(name)
}

/*
* ローカルストレージを全て削除
*/
export const clearLocalStore = () => {
  localStorage.clear()
}
/*
* セッションストレージにセット
*/
export const setSessionStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  sessionStorage.setItem(name, content)
}

/**
 * ローカルストレージから取得
 */
export const getSessionStore = name => {
  if (!name) return
  return sessionStorage.getItem(name)
}

/**
 * ローカルストレージから削除
 */
export const removeSessionStore = name => {
  if (!name) return
  sessionStorage.removeItem(name)
}

/*
* ローカルストレージを全て削除
*/
export const clearSessionStore = () => {
  sessionStorage.clear()
}



// WEBPACK FOOTER //
// ./src/store/utils/storage.js